import React, { forwardRef } from 'react';

import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';

export const TooltipIconButton = forwardRef((props, ref) => {
  const { children } = props;
  return (
    <IconButton style={{ alignItems: 'center', alignContent: 'center' }} ref={ref} {...props}>
      {children}
    </IconButton>
  );
});

TooltipIconButton.propTypes = {
  children: PropTypes.node.isRequired,
  ref: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};

TooltipIconButton.defaultProps = {
  ref: null,
};
TooltipIconButton.displayName = 'TooltipIconButton';
